const QF_Type = [
  "QUANTUM FIBER",
  "QF",
  "QF-II",
  "QUANTUM FIBER II",
];
const CTL_Type = [
  "CENTURY LINK",
  "CTL",
  "CTL QUALIFIED",
  "CTL_QUALIFIED",
  "COPPER QUALIFIED"
];
const migrated_CTL_Type = ["CENTURY LINK","CENTURY_LINK"]
const Other4GLTE_Type = [
  "4GLTE"
];

const initGTM = () => {
  window.dataLayer = window.dataLayer || [];
};
const predefinedCompanyName = {
  "QUANTUM FIBER":"QF",
  "QF":"QF",
  "QF-II":"QF",
  "QUANTUM FIBER II":"QF",
  "CENTURY LINK":"MIGRATED_CTL",
  "CTL":"CTL",
  "CTL QUALIFIED":"CTL",
  "CTL_QUALIFIED":"CTL",
  "COPPER QUALIFIED":"CTL",
  "4GLTE":"4GLTE",
  "CENTURY_LINK":"MIGRATED_CTL",
  "BS":"BRSPD"
  }
const getCustomerType = (companyName, chekIsMigrated = false) =>{
  let returnData ="";
  if(companyName && companyName !== null && companyName !== undefined && companyName !==""){
     returnData = predefinedCompanyName?.[companyName?.toString()?.toUpperCase()];
  }else{
    returnData = predefinedCompanyName?.[localStorage?.getItem("headersSiteId")?.toString()?.toUpperCase()];
    //returnData ="Comapany name not available";
  }
  return returnData === undefined ? "" : (returnData && chekIsMigrated && localStorage?.getItem("migratedCTLUser") === "true" )? "MIGRATED_CTL_Account_Management" : `${returnData}_Account_Management`;
  
   
}
const onPageLoadGTM = (
  pageName,
  step,
  sessionId,
  billingAccountNumber,
  companyName,
) => {
  window.dataLayer.push({
    page: {
      pageType: `${getCustomerType(companyName,true)}`,
      pageName: pageName || "",
    },
    flow: {
      name: "BRSPD_Fiber_EC_Flow",
      step: step || undefined,
    },
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};

const backButtonClickedGTM = (
  name,
  step,
  sessionId,
  billingAccountNumber,
  companyName
) => {
  window.dataLayer.push({
    event: "back",
    pageType: `${getCustomerType(companyName,true)}`,
    flow: {
      name: name,
      step: step,
    },
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};

const errorConditionGTM = (
  name,
  step,
  errorCode,
  errorName,
  sessionId,
  billingAccountNumber,
  companyName,
  loggedIn
) => {
  window.dataLayer.push({
    event: "error",
    pageType: `${getCustomerType(companyName,loggedIn)}`,
    flow: {
      name: name,
      step: step,
    },
    errorCode: errorCode,
    errorName: errorName,
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};
const LoginFlowErrorGTM = (
  stepName,
  errorCode,
  flowType,
  userStatus, 
  sessionId,
  event,
  companyName,
   loggedIn
) => {
  window.dataLayer.push({
    event: event,
    pageType: `${getCustomerType(companyName,loggedIn)}`,
    stepName: stepName,
    errorCode: errorCode,
    flowType: flowType,
    sessionId: sessionId,
    userStatus: userStatus,  
    channel: "digital",
  });
};



const finduserGTMWithFlow = (eventName) => {
  window.dataLayer.push({
    event: eventName,
    pageType:"",
    flow:"findusername",
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId")
  });
};
const findUserGTMErrorWithFlow = (eventName,errorMsg ) => {
  window.dataLayer.push({
    event: eventName,
    pageType:"",
    flow:"findusername",
    channel: "digital",
    errorCode:errorMsg,
    sessionId: localStorage?.getItem("sessionId")
  });
};

const loginGTM = (eventName, username, companyName, flowType, errorCode) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    //event: "digital_login_acct_mgmt",
    user: username,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    flow: flowType,
    errorCode: errorCode
  });
};

const shopConfirmOrderGTM = (orderNumber,orderDate,VasAdded,internetchange,voiceAddedOrRemoved,InternetPlanName,sessionId,existingPlanSpeed,internetChangeNewSpeedTiers) => {
  window.dataLayer.push({
    event: "change_Order_confirm_button",
    channel: "digital",
    orderNumber: orderNumber,
    orderdate: orderDate,
    total_home_tech_support:  VasAdded === "add" ? true : false,
    internetchange: internetchange,
    voiceAdded: voiceAddedOrRemoved === "add" ? true : false,
    voiceRemoved: voiceAddedOrRemoved === "delete" ? true : false,
    newInternetPlanName: InternetPlanName,
    existingPlanSpeed: existingPlanSpeed,
    newPlanSpeedTier: internetChangeNewSpeedTiers,
    sessionId: sessionId
  });
}

const forgotPasswordGTM = (companyName, username) => {
  window.dataLayer.push({
    event: "digital_forgot_password_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    user: username,
    sessionId: localStorage?.getItem("sessionId")
  });
};

const homeGTM = (companyName, accountType, accountTenure, accountStatus, autoPay, paperlessBilling, currentAmountDue,
  billDueDate,lastInvoiceAmount, lastBillDate, internet_plan_speed, stateCode, wireCenter, voice, offers1q,retentionOfferUser, addon) => {
  window.dataLayer.push({
    event: "digital_home_acct_mgmt",
    pageType: `${getCustomerType(companyName,true)}`,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    accountType: accountType,
    accountTenure: accountTenure,
    accountStatus: accountStatus,
    autoPay: autoPay,
    paperlessBilling: paperlessBilling,
    currentAmountDue: currentAmountDue,
    billDueDate: billDueDate,
    lastInvoiceAmount: lastInvoiceAmount,
    lastBillDate: lastBillDate,
    internet_plan_speed: internet_plan_speed,
    state_code: stateCode,
    wire_center: wireCenter,
    voice: voice,
    offers1q,
    retentionOfferUser,
    'Add-on': {
      'total_home_tech_support': addon?.total_home_tech_support,
      'wifi_extender': addon?.wifi_extender,
      'total_home_internet_control': addon?.total_home_internet_control,
    }
  });
};

const qbpPaymentsGTM = ({event, error = ""}) => {
  const companyName = localStorage?.getItem("headersSiteId");
  window.dataLayer.push({
    event,
    pageType: `${getCustomerType(companyName,true)}`,
    flow: "auth or nonauth qbp payments flow",
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    errorCode : error
  });
};


const payNowPaymentsGTM = ({event, error = ""}) => {
  const companyName = localStorage?.getItem("headersSiteId");
  window.dataLayer.push({
    event,
    pageType: `${getCustomerType(companyName,true)}`,
    flow: "auth or nonauth qbp payments flow",
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    error
  });
};
const upcomingPaymentGTM = (event, companyName, error, accountType,billingAccountNumber="") => {
  window.dataLayer.push({
    event: event,
    pageType:`${getCustomerType(companyName,true)}`,
    channel: "digital",
    errorCode: error,
    sessionId: localStorage?.getItem("sessionId"),
    accountType: accountType,
    billingAccountNumber: billingAccountNumber
  });
}
const AddUpdatePaymentGTM = (event, companyName,error,accountType,billingAccountNumber= "") => {
  window.dataLayer.push({
    event: event,
    pageType:`${getCustomerType(companyName,true)}`,
    channel: "digital",
    errorCode :error,
    sessionId: localStorage?.getItem("sessionId"),
    accountType: accountType,
    billingAccountNumber: billingAccountNumber,
  });
}

const authenticQbpGTM = ({flowType , companyName}) => {
  window.dataLayer.push({
    event: "digital_authentic_quickbillpay_acct_mgmt",
    pageType:`${getCustomerType(companyName,true)}`,
    flow: flowType,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId")
  });
};

const nonAuthenticQBPGTM = (
  {companyName, accountType, accountTenure, accountStatus, autoPay, paperlessBilling, currentAmountDue,
  billDueDate,lastInvoiceAmount, lastBillDate, internet_plan_speed, stateCode, wireCenter, voice, flowType}
) => {
  window.dataLayer.push({
    event: "digital_nonauthentic_quickbillpay_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    accountType,
    accountTenure,
    accountStatus,
    autoPay,
    paperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    internet_plan_speed,
    stateCode,
    wireCenter,
    voice,
    flowType,
    companyName
  });
};

const nonAuthenticPAGTM = (
  {companyName, accountType, accountTenure, accountStatus, autoPay, paperlessBilling, currentAmountDue,
  billDueDate,lastInvoiceAmount, lastBillDate, internet_plan_speed, stateCode, wireCenter, voice}
) => {
  window.dataLayer.push({
    event: "digital_nonauthentic_paymentarrangements_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    accountType,
    accountTenure,
    accountStatus,
    autoPay,
    paperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    internet_plan_speed,
    stateCode,
    wireCenter,
    voice
  });
};

// const accountSettingGTM = () => {
//   window.dataLayer.push({
//     event: "digital_account-setting_acct_mgmt",
//     channel: "digital",
//   });
// };

// const viewPaymentsGTM = () => {
//   window.dataLayer.push({
//     event: "digital_viewPayments_acct_mgmt",
//     channel: "digital",
//   });
// };

// const paymentMethodsGTM = () => {
//   window.dataLayer.push({
//     event: "digital_paymentMethods_mgmt",
//     channel: "digital",
//   });
// };

// const appointmentGTM = () => {
//   window.dataLayer.push({
//     event: "digital_appointment_mgmt",
//     channel: "digital",
//   });
// };

// const helpandsupportGTM = () => {
//   window.dataLayer.push({
//     event: "digital_help-and-support_mgmt",
//     channel: "digital",
//   });
// };

const sideMenuClickGTM = (eventName, companyName, username) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName,true)}`,
    channel: "digital",
    user: username,
    sessionId: localStorage?.getItem("sessionId")
  });
};

const forgotUserNameGTM = () => {
  window.dataLayer.push({
    event: "digital_forgot_username_acct_mgmt",
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId")
  });
};

const signupGTM = () => {
  window.dataLayer.push({
    event: "digital_create_account_acct_mgmt",
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId")
  });
};

const logoutGTM = (companyName, username) => {
  window.dataLayer.push({
    event: "digital_logout_acct_mgmt",
    pageType: `${getCustomerType(companyName,true)}`,
    channel: "digital",
    user: username,
    sessionId: localStorage?.getItem("sessionId")
  });
};

const addEneventGTM = (
  eventName,
  sessionId,
  billingAccountNumber,
  companyName
) => {
  window.dataLayer.push({
    event: eventName || undefined,
    pageType: `${getCustomerType(companyName,true)}`,
    channel: "digital",
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
  });
};

const uniLogineventGTM = (loginMethod, loginValue) => {
  window.dataLayer.push({
    event: "uni-login-account-management",
    pageType: "BRSPD_Fiber_Account_Management",
    channel: "digital",
    loginMethod: loginMethod,
    loginValue: loginValue,
    sessionId: localStorage?.getItem("sessionId")
  });
};

const forgetPasswordSuccessGTM = (eventName, flowType , companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    flow: flowType,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId")
  });
};

const payNowGTM = (eventName, flowType, companyName, billingAccountNumber, error = "") => { 
  window.dataLayer.push({
    event: eventName,
    pageType:`${getCustomerType(companyName,true)}`,
    flow: flowType,
    channel: "digital",
    sessionId: localStorage?.getItem("sessionId"),
    billingAccountNumber: billingAccountNumber,
    errorCode : error
  });
};


export {
  onPageLoadGTM,
  backButtonClickedGTM,
  errorConditionGTM,
  LoginFlowErrorGTM,
  initGTM,
  loginGTM,
  forgotPasswordGTM,
  forgotUserNameGTM,
  homeGTM,
  signupGTM,
  addEneventGTM,
  nonAuthenticQBPGTM,
  nonAuthenticPAGTM,
  shopConfirmOrderGTM,
  //paymentMethodsGTM,
  //helpandsupportGTM,
  //appointmentGTM,
  //accountSettingGTM,
  //viewPaymentsGTM,
  sideMenuClickGTM,
  uniLogineventGTM,
  logoutGTM,
  finduserGTMWithFlow,
  findUserGTMErrorWithFlow,
  forgetPasswordSuccessGTM,
  payNowGTM,
  authenticQbpGTM,
  qbpPaymentsGTM,
  upcomingPaymentGTM,
  AddUpdatePaymentGTM
};
